import { useState, useEffect } from 'react'
import { api } from '../services/api'

const ROLES = ['basico', 'intermediario', 'master']
const ROLE_LABEL = { basico: 'Básico', intermediario: 'Intermediário', master: 'Master' }

const formatarData = iso => {
  if (!iso) return '—'
  const [ano, mes, dia] = iso.split('T')[0].split('-')
  return `${dia}/${mes}/${ano}`
}

function ModalEditar({ usuario, onSalvo, onFechar }) {
  const [form, setForm] = useState({
    nome: usuario.nome,
    username: usuario.username,
    role: usuario.role,
    password: '',
    confirmar: '',
    ativo: usuario.ativo,
  })
  const [salvando, setSalvando] = useState(false)
  const [erro, setErro] = useState('')

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  const salvar = async () => {
    setErro('')
    if (form.password && form.password !== form.confirmar) return setErro('As senhas não coincidem.')
    if (form.password && form.password.length < 6) return setErro('Senha deve ter ao menos 6 caracteres.')
    setSalvando(true)
    try {
      const payload = { nome: form.nome, username: form.username, role: form.role, ativo: form.ativo }
      if (form.password) payload.password = form.password
      const atualizado = await api.usuarios.atualizar(usuario.id, payload)
      onSalvo(atualizado)
    } catch (e) {
      setErro(e.message)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '1rem' }}>
      <div style={{ background: 'var(--card-bg)', borderRadius: '22px', border: '1px solid var(--card-border)', padding: '2rem', width: '100%', maxWidth: '520px', boxShadow: '0 8px 40px rgba(0,0,0,0.35)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <h2 style={{ margin: 0, border: 'none', padding: 0 }}>Editar Usuário</h2>
          <button onClick={onFechar} style={{ padding: '6px 14px', fontSize: '12px' }}>Cancelar</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
          <div className="field" style={{ gridColumn: 'span 2' }}>
            <label>Nome completo</label>
            <input value={form.nome} onChange={e => set('nome', e.target.value)} />
          </div>
          <div className="field">
            <label>Username (login)</label>
            <input value={form.username} onChange={e => set('username', e.target.value)} />
          </div>
          <div className="field">
            <label>Perfil</label>
            <select value={form.role} onChange={e => set('role', e.target.value)}>
              {ROLES.map(r => <option key={r} value={r}>{ROLE_LABEL[r]}</option>)}
            </select>
          </div>
          <div className="field">
            <label>Nova senha (opcional)</label>
            <input type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder="Deixe vazio para manter" />
          </div>
          <div className="field">
            <label>Confirmar nova senha</label>
            <input type="password" value={form.confirmar} onChange={e => set('confirmar', e.target.value)} />
          </div>
          <div className="field" style={{ gridColumn: 'span 2', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
            <input type="checkbox" id="ativo-edit" checked={form.ativo} onChange={e => set('ativo', e.target.checked)} style={{ width: 'auto !important' }} />
            <label htmlFor="ativo-edit" style={{ textTransform: 'none', fontSize: '13px !important', color: 'var(--text-primary) !important' }}>Usuário ativo</label>
          </div>
        </div>

        {erro && <div className="badge-err" style={{ marginTop: '1rem' }}>{erro}</div>}

        <button className="btn-gold" onClick={salvar} disabled={salvando} style={{ marginTop: '1.5rem' }}>
          {salvando ? 'SALVANDO...' : 'SALVAR ALTERAÇÕES'}
        </button>
      </div>
    </div>
  )
}

function ModalExcluir({ usuario, onExcluido, onFechar }) {
  const [justificativa, setJustificativa] = useState('')
  const [excluindo, setExcluindo] = useState(false)
  const [erro, setErro] = useState('')

  const excluir = async () => {
    setErro('')
    if (justificativa.trim().length < 10) return setErro('Informe uma justificativa (mínimo 10 caracteres).')
    setExcluindo(true)
    try {
      await api.usuarios.excluir(usuario.id, justificativa.trim())
      onExcluido(usuario.id)
    } catch (e) {
      setErro(e.message)
    } finally {
      setExcluindo(false)
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '1rem' }}>
      <div style={{ background: 'var(--card-bg)', borderRadius: '22px', border: '1px solid var(--card-border)', padding: '2rem', width: '100%', maxWidth: '480px', boxShadow: '0 8px 40px rgba(0,0,0,0.35)' }}>
        <h2 className="text-danger" style={{ margin: '0 0 0.5rem', border: 'none', padding: 0 }}>Excluir Usuário</h2>
        <p style={{ fontSize: '14px', color: 'var(--text-primary)', margin: '0 0 1.25rem' }}>
          Você está prestes a excluir <strong>{usuario.nome}</strong> ({usuario.username}). Esta ação ficará registrada no Log do sistema.
        </p>

        <div className="field" style={{ marginBottom: '1rem' }}>
          <label>Justificativa *</label>
          <textarea
            rows={3}
            value={justificativa}
            onChange={e => setJustificativa(e.target.value)}
            placeholder="Descreva o motivo da exclusão..."
            style={{ resize: 'vertical' }}
          />
        </div>

        {erro && <div className="badge-err">{erro}</div>}

        <div style={{ display: 'flex', gap: '10px', marginTop: '1.25rem' }}>
          <button onClick={onFechar} style={{ flex: 1 }}>Cancelar</button>
          <button
            onClick={excluir}
            disabled={excluindo}
            style={{ flex: 1, background: '#7A2A2A', color: 'white', border: 'none', borderRadius: '14px', padding: '10px', fontSize: '13px', cursor: 'pointer', fontFamily: 'Georgia, serif' }}
          >
            {excluindo ? 'EXCLUINDO...' : 'CONFIRMAR EXCLUSÃO'}
          </button>
        </div>
      </div>
    </div>
  )
}

function FormNovoUsuario({ onCriado }) {
  const [form, setForm] = useState({ username: '', nome: '', role: 'basico', password: '', confirmar: '' })
  const [salvando, setSalvando] = useState(false)
  const [erro, setErro] = useState('')
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  const criar = async () => {
    setErro('')
    if (!form.username || !form.nome || !form.password) return setErro('Preencha todos os campos.')
    if (form.password !== form.confirmar) return setErro('As senhas não coincidem.')
    if (form.password.length < 6) return setErro('Senha deve ter ao menos 6 caracteres.')
    setSalvando(true)
    try {
      const novo = await api.usuarios.criar({ username: form.username, nome: form.nome, password: form.password, role: form.role })
      onCriado(novo)
      setForm({ username: '', nome: '', role: 'basico', password: '', confirmar: '' })
    } catch (e) {
      setErro(e.message)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div className="card">
      <h2>Novo usuário</h2>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <div className="field">
          <label>Nome completo</label>
          <input value={form.nome} onChange={e => set('nome', e.target.value)} />
        </div>
        <div className="field">
          <label>Username (login)</label>
          <input value={form.username} onChange={e => set('username', e.target.value)} />
        </div>
        <div className="field">
          <label>Perfil</label>
          <select value={form.role} onChange={e => set('role', e.target.value)}>
            {ROLES.map(r => <option key={r} value={r}>{ROLE_LABEL[r]}</option>)}
          </select>
        </div>
        <div className="field">
          <label>Senha</label>
          <input type="password" value={form.password} onChange={e => set('password', e.target.value)} />
        </div>
        <div className="field" style={{ gridColumn: 'span 1' }}>
          <label>Confirmar senha</label>
          <input type="password" value={form.confirmar} onChange={e => set('confirmar', e.target.value)} />
        </div>
      </div>
      {erro && <div className="badge-err" style={{ marginTop: '1rem' }}>{erro}</div>}
      <div style={{ marginTop: '1.25rem' }}>
        <button className="btn-gold" onClick={criar} disabled={salvando} style={{ width: 'auto', padding: '10px 28px' }}>
          {salvando ? 'CRIANDO...' : 'CRIAR USUÁRIO'}
        </button>
      </div>
    </div>
  )
}

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([])
  const [loading, setLoading] = useState(true)
  const [editando, setEditando] = useState(null)
  const [excluindo, setExcluindo] = useState(null)
  const [sucesso, setSucesso] = useState('')

  useEffect(() => {
    api.usuarios.listar().then(setUsuarios).catch(() => {}).finally(() => setLoading(false))
  }, [])

  const onCriado = (novo) => {
    setUsuarios(us => [...us, novo])
    setSucesso(`Usuário "${novo.username}" criado.`)
    setTimeout(() => setSucesso(''), 4000)
  }

  const onSalvo = (atualizado) => {
    setUsuarios(us => us.map(u => u.id === atualizado.id ? atualizado : u))
    setEditando(null)
    setSucesso(`Usuário "${atualizado.username}" atualizado.`)
    setTimeout(() => setSucesso(''), 4000)
  }

  const onExcluido = (id) => {
    setUsuarios(us => us.filter(u => u.id !== id))
    setExcluindo(null)
    setSucesso('Usuário excluído. Registro salvo no Log.')
    setTimeout(() => setSucesso(''), 5000)
  }

  return (
    <div>
      <h1 style={{ fontSize: '20px', fontWeight: 'normal', letterSpacing: '0.06em', margin: '0 0 1.5rem', color: 'var(--text-primary)' }}>USUÁRIOS</h1>

      {sucesso && <div className="badge-ok" style={{ marginBottom: '1rem' }}>{sucesso}</div>}

      <FormNovoUsuario onCriado={onCriado} />

      <div className="card">
        <h2>Usuários cadastrados ({usuarios.length})</h2>
        {loading ? (
          <p style={{ color: 'var(--text-secondary)', margin: 0 }}>Carregando...</p>
        ) : (
          <table>
            <thead>
              <tr>{['Nome', 'Username', 'Perfil', 'Desde', 'Status', ''].map(h => <th key={h}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {usuarios.map(u => (
                <tr key={u.id}>
                  <td style={{ fontWeight: 'bold' }}>{u.nome}</td>
                  <td style={{ color: 'var(--text-secondary)' }}>{u.username}</td>
                  <td>
                    <span className={`sb r-${u.role}`}>
                      {ROLE_LABEL[u.role]}
                    </span>
                  </td>
                  <td>{formatarData(u.created_at)}</td>
                  <td>
                    <span className={`sb ${u.ativo ? 's-ativo-badge' : 's-inativo-badge'}`}>
                      {u.ativo ? 'ativo' : 'inativo'}
                    </span>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <div style={{ display: 'flex', gap: '6px', justifyContent: 'flex-end' }}>
                      <button onClick={() => setEditando(u)} className="btn-amber" style={{ fontSize: '12px', padding: '5px 12px' }}>
                        Editar
                      </button>
                      <button onClick={() => setExcluindo(u)} className="btn-danger-outline" style={{ fontSize: '12px', padding: '5px 12px' }}>
                        Excluir
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {editando && <ModalEditar usuario={editando} onSalvo={onSalvo} onFechar={() => setEditando(null)} />}
      {excluindo && <ModalExcluir usuario={excluindo} onExcluido={onExcluido} onFechar={() => setExcluindo(null)} />}
    </div>
  )
}
